import { AUTH_VERIFY } from './constants';
import fetchWithRefreshV2 from './fetchWithRefreshV2';

export interface Response {
    success: boolean;
    status: number;
    error: Error;
}

export interface Error {
    type: string;
    message: string;
}

export default (magiclink_hash: string = ''): Promise<Response> => {
    return fetchWithRefreshV2(AUTH_VERIFY, {
        method: 'POST',
        body: JSON.stringify({
            type: 'magic-link',
            payload: {
                link_key: magiclink_hash,
            },
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((res) => res.json());
};
